import { useEffect } from 'react';

import { redirectTo } from '@consumer-frontend/nc-utils';

import { useOptimizelyFeature } from './useOptimizelyFeature';
import { accountHomeBaseUrl } from '../lib/endpoints';

const MAINTENANCE_MODE_FLAG = 'account_home_maintenance_mode';

export const useMaintenanceMode = () => {
  const isMaintenanceModeEnabled = useOptimizelyFeature(MAINTENANCE_MODE_FLAG);

  useEffect(() => {
    if (isMaintenanceModeEnabled) {
      redirectTo(accountHomeBaseUrl);
    }
  }, [isMaintenanceModeEnabled]);
};
